<script lang="ts">
    import type {LayoutRowPartWidth} from 'shared/layouts/grid-system/built-layout/types';
    import type {CssSize} from 'shared/ui-widgets/types';
    import {createGridSystemContext} from 'shared/layouts/grid-system/grid-system-context';

    export let id: string | null = null;
    export let additionalClasses = '';
    export let gap: CssSize = '30px';
    export let topMargin: CssSize = '40px';
    export let rowsWidth: LayoutRowPartWidth = 'default';
    export let align: 'start' | 'center' | 'end' | 'initial' = 'center';

    createGridSystemContext(rowsWidth);
</script>

<div id={id}
     class="kp-layout-grid-container {additionalClasses}"
     style:--flex-align={align}
     style:--margin-top={topMargin}
     style:--gap={gap ?? '0px'}>

    <slot/>
</div>

<style lang="less">
    .kp-layout-grid-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: var(--gap);
        align-items: var(--flex-align);
        margin-top: var(--margin-top);
    }

    :global {
        .kp-layout-grid-container .panel {
            margin-bottom: 0;
        }
    }
</style>